import { render, staticRenderFns } from "./DsAppForm.vue?vue&type=template&id=1e51597c&scoped=true"
import script from "./DsAppForm.vue?vue&type=script&lang=js"
export * from "./DsAppForm.vue?vue&type=script&lang=js"
import style0 from "./DsAppForm.vue?vue&type=style&index=0&id=1e51597c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e51597c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\cxy\\project\\zcy\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e51597c')) {
      api.createRecord('1e51597c', component.options)
    } else {
      api.reload('1e51597c', component.options)
    }
    module.hot.accept("./DsAppForm.vue?vue&type=template&id=1e51597c&scoped=true", function () {
      api.rerender('1e51597c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/datasource/DsAppForm.vue"
export default component.exports